import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { CONSULTANTS } from "../data/consultants";

export default function Consultants() {
  return (
    <div data-testid="consultants-page">
      <SEO title="Consultant Physicians & Heart Doctors in Cambridge" description="Meet our Cambridge consultant physicians - specialists in hypertension (high blood pressure), cardiovascular medicine, general internal medicine, diabetes and metabolic health, and echocardiography." path="/consultants" />
      <section className="bg-cream-100 border-b border-bronze-light/30">
        <div className="container-ccc py-20 max-w-4xl">
          <div className="eyebrow">Meet the team · Consultant-led hypertension &amp; cardiovascular prevention</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.02]">
            A specialist team of <em className="font-serif text-bronze-dark">Cambridge</em> consultants — who help shape UK practice.
          </h1>
          <p className="mt-6 text-ink-muted text-lg leading-relaxed">
            Every appointment is with a named, senior consultant — the same doctors you’d see in the NHS at Cambridge University Hospitals. Professor Ian Wilkinson, one of our consultants, is Immediate Past-President of the British and Irish Hypertension Society and a co-author of the UK’s national hypertension guidelines.
          </p>
        </div>
      </section>

      <section className="container-ccc py-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {CONSULTANTS.map((c) => (
          <Link
            key={c.slug}
            to={`/consultants/${c.slug}`}
            data-testid={`consultant-card-${c.slug}`}
            className="group bg-white border border-stone-200/60 rounded-md overflow-hidden hover:-translate-y-1 hover:shadow-md transition-all"
          >
            <div className="aspect-[4/5] overflow-hidden bg-cream-100">
              <img src={c.image} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-5">
              <div className="font-serif text-xl leading-tight">{c.name}</div>
              <div className="eyebrow mt-2 text-[10px]">{c.title}</div>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {c.specialties.map((sp) => (
                  <span key={sp} className="text-[10px] uppercase tracking-widest text-bronze-dark/90 border border-bronze-light/60 rounded-full px-2 py-0.5">{sp}</span>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}
